export default __webpack_public_path__ + "static/media/pokemonLogo.21a0c782.png";